import VirtualHelpdesk from '@/views/VirtualHelpdesk/index.vue'

const VirtualHelpdeskRouter = {
  path: '/virtual-helpdesk',
  name: 'VirtualHelpdesk',
  component: VirtualHelpdesk,
  props: (route) => ({
    token: route.query.token
  })
}

export default VirtualHelpdeskRouter
